import { createSlice } from '@reduxjs/toolkit'
import { getRecords } from '../../lib/pouchDb'
import { onError } from '../../lib/sentry'

const initialState = {
  locations: [],
  deletedLocations: [],
  activeLocations: [],
  isLoading: false,
  error: null
}

const location = createSlice({
  name: 'location',
  initialState,
  reducers: {
    getLocationStart(state) {
      state.isLoading = true
      state.error = null
    },
    getLocationSuccess(state, action) {
      const { locations } = action.payload
      state.locations = locations
      state.deletedLocations = locations.filter(item => item.deleted)
      state.activeLocations = locations.filter(item => !item.deleted)
      state.isLoading = false
      state.error = null
    },
    getLocationFailure(state, action) {
      state.isLoading = false
      state.error = action.payload
    }
  }
})

export const {
  getLocationStart,
  getLocationSuccess,
  getLocationFailure
} = location.actions

export default location.reducer

export const fetchLocations = (userId, masterKey) => async dispatch => {
  try {
    dispatch(getLocationStart())
    const locations = await getRecords(userId, 'locations', masterKey)
    dispatch(getLocationSuccess({ locations }))
  } catch (err) {
    onError(err)
    dispatch(getLocationFailure(err.toString()))
  }
}
